import { getPlayer } from '../../../player/playerService';

import type Tracker from '@spt-tracking/pulse-sdk';

export const syncPageViewId = async (tracker: Tracker) => {
  const player = await getPlayer();

  const getTracker = async () => {
    const playerTracker = await player
      .getPlugin('PulseStats')
      ?.getTrackerOrNull();

    if (!playerTracker) {
      return;
    }

    const originalNewPageView = tracker.newPageView;

    tracker.newPageView = () => {
      originalNewPageView.call(tracker);

      playerTracker.state.pageViewId = tracker.getPageViewId();
    };
  };

  if (player.getPlugin('PulseStats')) {
    getTracker();
  } else {
    player.once('PulseStats:ready', getTracker);
  }
};

export const exposePulseInstanceAsGlobal = (tracker: Tracker) => {
  const _pulse = window.pulse;

  // @ts-expect-error too complex
  window.pulse = (...args) => {
    // @ts-expect-error too complex
    if (typeof args[0] === 'function' && args.length === 1) {
      args[0](tracker);
    } else {
      // @ts-expect-error too complex
      _pulse!(...args);
    }
  };
  // restore original queue with polluted prototype
  // ref https://github.schibsted.io/spt-dataanalytics/pulse-sdk-js/blob/master/workspaces/autotracker/src/pulse.js#L184
  window.pulse!.q = _pulse!.q || [];
};
